import { combineReducers } from "redux";
import filterReducer from "./FilterReducer";
import tableReducer from "./TableReducer";
import diamondReducer from "./DiamondReducer";
import ringReducer from "./RingReducer";
import headerReducer from './HeaderReducer';
import startWithSettingFilterReducer from "./StartWithSettingFilterReducer";
import footerReducer from "./FooterReducer";
import tooltipReducer from "./TooltipReducer";
import stateManagerReducer from './StateManagerReducer';
import cartReducer from "./CartReducer";
import spinToWinReducer from "./SpinToWinReducer";

export const RESET_ALL = 'RESET_ALL';

const appReducer = combineReducers({
    filter: filterReducer,
    header: headerReducer,
    table: tableReducer,
    diamond: diamondReducer,
    ring: ringReducer,
    settingFilter: startWithSettingFilterReducer,
    tooltip: tooltipReducer,
    footer: footerReducer,
    stateManager: stateManagerReducer,
    cart: cartReducer,
    spinToWin: spinToWinReducer,
});

const RootReducer = (state: any, action: any) => {
    if (action.type === RESET_ALL) {
        // Preserve stateManager so ScreenManager keeps its current path/route
        const { stateManager } = state ?? {};
        state = undefined;
        return appReducer({ stateManager } as any, action);
    }
    return appReducer(state, action);
};

export type RootState = ReturnType<typeof appReducer>;
export default RootReducer;
